import { ICompanyContactPackageBuider } from './companyContactPackageBuilder';
import { IPackageBuilderZone } from './packageBuilderZone';

export class IPackageBuider {
    _id                      : string;
    sn                       : number;
    packageName              : string;
    packageType              : string;
    logo                     : string;
    color                    : string;
    noOfMonths               : number;
    noOfWeeks                : number;
    noOfDays                 : number;
    durationType             : string;
    isDelete                 : boolean;
    noOfMembers              : number;
    description              : string;
    packageFee               : number;
    registerationFee         : number;
    companyContactPerson     : ICompanyContactPackageBuider
    packageFeeType           : string;
    packageRegFeeType        : string;
    isGreaterthanNoOfMembers : boolean;
    branch                   : string;
    company                  : string;
    createdBy                : string;
    createdDate              : Date;
    modifiedBy               : string;
    scope                    : string;
    type                     : string;
    initiatedFrom            : string;
    activityBy               : string;
    ageGroupFrom             : number;
    ageGroupTo               : number;
    modifiedDate             : Date;
    zones                    : IPackageBuilderZone[];
    groupFeePayByOnePerson   : boolean;
}